import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Carousels from './carousel';
import Footer from './footer';
import Navbars from './Navbar';

const Exportresult = () => {
const location = useLocation();
const navigate = useNavigate();
const [selectedCsbNo, setSelectedCsbNo] = useState(null);
  if (!location.state) {
    return <div className="text-center mt-5">CSB not filed. Please search again.</div>;
  }
  const {
    exportDetails,
    hawbNo,
    courierName,
    errorMessage,
    status,
    csbNoList,
    multipleExport,
    exportDetailsList = {},
    errorList,
  } = location.state;
  const mergedData = {
    ...exportDetails,
    hawbNo,
    courierName,
  };

  const displayFields = [
    { fieldKey: "csbNo", label: "BOE No" },
    { fieldKey: "csbDate", label: "CBE Filed Date" },
    { fieldKey: "assessableValue", label: "Assessable Value" },
    { fieldKey: "totalDuty", label: "Total Custom Duty" },
    { fieldKey: "status", label: "Current Status" },
    { fieldKey: "detail_description", label: "Detail Description about Current Status" },
    { fieldKey: "status_date", label: "Status Date" },
    { fieldKey: "hawbNo", label: "HAWB NO" },
    { fieldKey: "courierName", label: "Courier Co" },
  ];

  const handleCsbClick = (csbName) => {
    navigate('/csbDetails', {
      state: { csbName, hawbNo, courierName, exportDetailsList }
    });
  };

  return (
    <div className="container-fixed">
      <Navbars />
      <Carousels />
      <Container className="mt-4 import-form-carousel">
        <h3 className="text-center mb-4">Export</h3>
        {status === "FAILURE" ? (
         <div className="alert alert-danger text-center">
            {errorList && errorList.length > 0 ? (errorList.map((error, idx) => (
                <div key={idx}>{error}</div>
              ))
            ) : (
              errorMessage || "Error fetching export data."
            )}
 
          </div>
          ) : status === "SUCCESS" && multipleExport === false && (!Array.isArray(csbNoList) || csbNoList.length === 0) ? (
          <div className="alert alert-warning text-center">
              CSB not filed. Please search again.
          </div>): Array.isArray(csbNoList) && csbNoList.length > 1 ? (
          <>
            <div>
              <ul className="list-group">
                {csbNoList.map((csbNo, idx) => (
                  <li
                    key={idx}
                    className={`list-group-item ${selectedCsbNo === csbNo ? 'active' : ''}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleCsbClick(csbNo)}
                  >
                    {csbNo}
                  </li>
                ))}
              </ul>

              {selectedCsbNo && (
                <div className="mt-4">
                  <table className="table table-bordered table-striped table-sm">
                    <tbody>
                      {displayFields.map(({ fieldKey, label }) => {
                        const detail = exportDetailsList[selectedCsbNo] || mergedData;
                        return detail[fieldKey] ? (
                          <tr key={fieldKey}>
                            <td>{label}</td>
                            <td>{detail[fieldKey]}</td>
                          </tr>

                        ) : null;

                      })}
                    </tbody>
                  </table>
                </div>

              )}
            </div>
          </>

        ) : Array.isArray(csbNoList) && csbNoList.length === 1 ? (

          <table className="table table-bordered table-striped table-sm">
            <tbody>
              {displayFields.map(({ fieldKey, label }) =>
                mergedData[fieldKey] ? (
                  <tr key={fieldKey}>
                    <td>{label}</td>
                    <td>{mergedData[fieldKey]}</td>
                  </tr>

                ) : null
              )}
            </tbody>
          </table>

        ) : exportDetails ? (
          <table className="table table-bordered table-striped table-sm">
            <tbody>
              {displayFields.map(({ fieldKey, label }) =>
                mergedData[fieldKey] ? (
                  <tr key={fieldKey}>
                    <td>{label}</td>
                    <td>{mergedData[fieldKey]}</td>
                  </tr>

                ) : null
              )}
            </tbody>
          </table>
        ) : (
          <div className="text-center">No data available.</div>
        )}
        <br></br>
        <button type="button" className="btn btn-danger submit-btn return-btn" onClick={() => navigate('/export')}
        >RETURN
        </button>
      </Container>
      <Footer />
    </div>
  );
};
export default Exportresult;

